/* NEOGEN — Header Custom Behavior */
(function () {
  'use strict';

  /* ── PC: Hover to open mega menu ── */
  function initHoverMenu() {
    if (window.innerWidth < 990) return;

    var headerMenu = document.querySelector('.header__inline-menu');
    if (!headerMenu) return;

    headerMenu.querySelectorAll('li').forEach(function (li) {
      var details = li.querySelector('details');
      if (!details) return;

      var closeTimer = null;

      function openMenu() {
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
      }

      function scheduleClose() {
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
        }, 150);
      }

      li.addEventListener('mouseenter', openMenu);
      li.addEventListener('mouseleave', scheduleClose);

      // Mega menu uses .mega-menu__content, standard dropdown uses .header__submenu
      var submenu = details.querySelector('.mega-menu__content, .header__submenu');
      if (submenu) {
        submenu.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
        });
        submenu.addEventListener('mouseleave', scheduleClose);
      }
    });
  }

  /* ── Mobile: Convert drill-down to accordion ── */
  function initMobileAccordion() {
    if (window.innerWidth >= 990) return;

    var drawer = document.querySelector('header-drawer');
    if (!drawer) return;

    // Clone each submenu summary to strip Dawn's onSummaryClick handler.
    // Removing Dawn's handler prevents .menu-opening and .submenu-open classes
    // from being added — those classes drive the full-panel slide and hide the
    // parent list. Native <details> toggle continues to manage [open].
    // CSS in neogen-header-overrides.css handles show/hide of the submenu inline.
    drawer.querySelectorAll('summary.menu-drawer__menu-item').forEach(function (summary) {
      var clone = summary.cloneNode(true);
      summary.parentNode.replaceChild(clone, summary);
    });
  }

  /* ── PC: Click top-level item with submenu → go to its link ──
     Only summaries rendered with data-href (link not empty / "#").
     Mouse click navigates. Keyboard (Enter/Space, detail 0) keeps Dawn's
     open/close. Touch: first tap opens, tap again while open navigates. */
  function initTopLevelLinks() {
    var desktop = window.matchMedia('(min-width: 990px)');

    document.querySelectorAll('.header__inline-menu summary[data-href]').forEach(function (summary) {
      var details = summary.parentElement;
      var pointerType = null;
      var wasOpen = false;

      summary.addEventListener('pointerdown', function (event) {
        pointerType = event.pointerType;
        wasOpen = details.hasAttribute('open');
      });

      summary.addEventListener('click', function (event) {
        var type = pointerType;
        pointerType = null;
        if (!desktop.matches || event.detail === 0 || !type) return;

        event.preventDefault();

        if (type === 'touch' && !wasOpen) {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
          return;
        }

        var href = summary.getAttribute('data-href');
        if (event.metaKey || event.ctrlKey || event.shiftKey) {
          window.open(href, '_blank', 'noopener');
        } else {
          window.location.href = href;
        }
      });
    });
  }

  function init() {
    initHoverMenu();
    initTopLevelLinks();
    initMobileAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
